import FeatureLayer from "@arcgis/core/layers/FeatureLayer.js";
import GroupLayer from "@arcgis/core/layers/GroupLayer.js";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer.js";
import PopupTemplate from "@arcgis/core/PopupTemplate.js";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer.js";
import SimpleRenderer from "@arcgis/core/renderers/SimpleRenderer.js";
import Color from "@arcgis/core/Color.js";
import SimpleLineSymbol from "@arcgis/core/symbols/SimpleLineSymbol.js";

const popuptempl_1D = new PopupTemplate({
    title: "1D water-op-straat",
    content: `<table style="width: 100%; border-collapse: collapse;">
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{id}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">overstromingsvolume:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/FloodVol} m³</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">waterdiepte t.o.v. maaiveld (max.):</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/FloodDepth} m</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">waterpeil (max.):</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/DEPNOD} m NAP</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">type knoop:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{node_type}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">systeem type:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{system_typ}</td>
                </tr>
            </table>`,    
    expressionInfos: [
        {
            name: "FloodVol",
            expression: "if ($feature.FloodVol >= 0) { return Round($feature.FloodVol, 1); } else { return 0; }"
        },
        {
            name: "FloodDepth",
            expression: "Round($feature.FloodDepth, 2)"
        },
        {
            name: "DEPNOD",
            expression: "Round($feature.DEPNOD, 2)"
        }
    ]
});

const popuptempl_2Dpand = new PopupTemplate({
    title: "2D risicopanden",
    content: `<table style="width: 100%; border-collapse: collapse;">
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">klasse:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{depth_clas}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">maximale waterdiepte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/FloodDepth} m</td>
                </tr>
            </table>`,    
    expressionInfos: [
        {
            name: "FloodDepth",
            expression: "Round($feature.max_adj_de, 2)"
        }
    ]
});

const popuptempl_2Dwos = new PopupTemplate({
    title: "2D water-op-straat",
    content: `<table style="width: 100%; border-collapse: collapse;">
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">waterdiepte (max.):</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/DEPTH2D} m</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">maaiveldhoogte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/GNDLEV2D} m NAP</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">waterpeil (max.):</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/elevation2} m NAP</td>
                </tr>
            </table>`,    
    expressionInfos: [
        {
            name: "DEPTH2D",
            expression: "Round($feature.DEPTH2D, 2)"
        },
        {
            name: "GNDLEV2D",
            expression: "Round($feature.GNDLEV2D, 2)"
        },
        {
            name: "elevation2",
            expression: "Round($feature.elevation2, 2)"
        }
    ]
});

const netwerk_BA = new PopupTemplate({
    title: "Blauwe aderen",
    content: `<table style="width: 100%; border-collapse: collapse;">
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode Bov:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{us_node_id}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">suffix:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{link_suffi}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode Ben:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{ds_node_id}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">systeem type:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{system_typ}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">lengte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/LENGTH} m</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">vorm:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{shape_1}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">breedte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/WIDTH} mm</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">hoogte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/HEIGHT} mm</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">bob Bov:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{us_invert} m NAP</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">bob Ben:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{ds_invert} m NAP</td>
                </tr>
            </table>`,    
    expressionInfos: [
        {
            name: "LENGTH",
            expression: "Round($feature.conduit_le, 1)"
        },
        {
            name: "WIDTH",
            expression: "Round($feature.conduit_wi, 2)"
        },
        {
            name: "HEIGHT",
            expression: "Round($feature.conduit_he, 2)"
        }
    ]
});

const netwerk_HWA_GEM= new PopupTemplate({
    title: "Verbindingen HWA-GEM ",
    content: `<table style="width: 100%; border-collapse: collapse;">
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{node_id}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">verbinding:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{verbinding}</td>
                </tr>
            </table>`
});

const netwerk_putten = new PopupTemplate({
    title: "Putten",
    content: `<table style="width: 100%; border-collapse: collapse;">
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{node_id}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">type knoop:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{node_type}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">systeem type:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{system_typ}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putdekselhoogte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/putdekselhoogte} m NAP</td>
                </tr>                
            </table>`,    
    expressionInfos: [
        {
            name: "putdekselhoogte",
            expression: "Round($feature.ground_lev, 2)"
        }
    ]
});

const netwerk_leidingen = new PopupTemplate({
    title: "Leidingen",
    content: `<table style="width: 100%; border-collapse: collapse;">
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode Bov:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{us_node_id}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">suffix:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{link_suffi}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode Ben:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{ds_node_id}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">systeem type:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{system_typ}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">lengte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/LENGTH} m</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">vorm:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{shape_1}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">breedte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/WIDTH} mm</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">hoogte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/HEIGHT} mm</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">bob Bov:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{us_invert} m NAP</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">bob Ben:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{ds_invert} m NAP</td>
                </tr>
            </table>`,    
    expressionInfos: [
        {
            name: "LENGTH",
            expression: "Round($feature.conduit_le, 1)"
        },
        {
            name: "WIDTH",
            expression: "Round($feature.conduit_wi, 2)"
        },
        {
            name: "HEIGHT",
            expression: "Round($feature.conduit_he, 2)"
        }
    ]
});

const netwerk_overstorten = new PopupTemplate({
    title: "Overstorten GEM",
    content: `<table style="width: 100%; border-collapse: collapse;">
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode Bov:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{us_node_id}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">suffix:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{link_suffi}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode Ben:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{ds_node_id}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">drempelhoogte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/CREST} m NAP</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">drempelbreedte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/WIDTH} m</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">vrije hoogte:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/HEIGHT}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">bron:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{bron}</td>
                </tr>
            </table>`,    
    expressionInfos: [
        {
            name: "CREST",
            expression: "Round($feature.crest, 2)"
        },
        {
            name: "WIDTH",
            expression: "Round($feature.width, 2)"
        },
        {
            name: "HEIGHT",
            //expression: "Round($feature.height, 2)"
            expression: "IIF(IsEmpty($feature.height) || $feature.height == 0, 'onbekend', Text($feature.height)+' m')",
        }
    ]
});

const netwerk_gemalen = new PopupTemplate({
    title: "Gemalen",
    content: `<table style="width: 100%; border-collapse: collapse;">
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">putcode:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{node_id}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">systeem type:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{system_typ}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">aantal pompen:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{aantal}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">type pomp:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{link_type}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">inslagpeil:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/ON}</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">uitslagpeil:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{expression/OFF}</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">Pompcap. 1:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{max_pump1} m³/u</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">Pompcap. 2:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{max_pump2} m³/u</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">Pompcap. 3:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{max_pump3} m³/u</td>
                </tr>
                <tr style="background-color: #e3f2fd;">
                    <td style="padding: 8px; border: 1px solid #ddd;">Pompcap. 4:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{max_pump4} m³/u</td>
                </tr>
                <tr style="background-color: #ffffff;">
                    <td style="padding: 8px; border: 1px solid #ddd;">Pompcap. totaal:</td>
                    <td style="padding: 8px; border: 1px solid #ddd;">{max_total} m³/u</td>
                </tr>                                
            </table>`,    
    expressionInfos: [
        {
            name: "ON",            
            expression: "if($feature.switch_on == 'variable'){return $feature.switch_on;} else {return $feature.switch_on + ' m NAP';}"
        },
        {
            name: "OFF",
            expression: "if($feature.switch_off == 'variable'){return $feature.switch_off;} else {return $feature.switch_off + ' m NAP';}"
        }
    ]
});
//------------------------------------------------------
//--------------- NETWERK SCI --------------------------
//------------------------------------------------------    
const netwerk1 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/1",
    title: "Putten",
    visible: true,
    outFields: ["*"],    
    popupTemplate: netwerk_putten
});
const netwerk2 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/2",
    title: "Leidingen",
    visible: true,
    outFields: ["*"],
    popupTemplate: netwerk_leidingen
});
//---------------------------------
let OverlaatRenderer = new SimpleRenderer({
    symbol: {
    type: "simple-marker", 
    style: "square",
    size: 12,
    color: [255, 255, 255, 1.0],
    outline: { 
      width: 0.0,
      color: "white"
    }
    }
});
const netwerk3c = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/4",
    title: "Overstorten GEM",
    visible: true,
    legendEnabled: false,
    renderer: OverlaatRenderer,            
    popupTemplate: netwerk_overstorten
});
const netwerk3b = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/5",
    title: "Weirs GEM lines",
    visible: true    
});
const netwerk3a = new MapImageLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer",
    title: "Weirs GEM point",
    listMode: "hide-children",
    visible: true,    
    sublayers: [
        {
            id: 4,
            visible: true
        }
    ]
});
const netwerk3 = new GroupLayer({
    title: "Overstorten GEM",
    layers: [netwerk3c, netwerk3b, netwerk3a],
    visible: true,
    listMode: "hide-children"
});
//--------------------------------
const netwerk6 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/6",
    title: "Verbindingen HWA-GEM",
    visible: true,
    labelsVisible: false,
    outFields: ["*"],    
    popupTemplate: netwerk_HWA_GEM
});
//---------------------------------
let GemaalRenderer = new SimpleRenderer({
    symbol: {
    type: "simple-marker", 
    style: "circle",
    size: 14,
    color: [255, 255, 255, 1.0],
    outline: { 
      width: 0.0,
      color: "white"
    }
    }
});
const netwerk7c = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/8",
    title: "Gemalen",
    visible: true,
    legendEnabled: false,
    renderer: GemaalRenderer,            
    popupTemplate: netwerk_gemalen
});
const netwerk7b = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/9",
    title: "Pumps",
    visible: true    
});
const netwerk7a = new MapImageLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer",
    title: "Nodes_pompputten",
    listMode: "hide-children",
    visible: true,    
    sublayers: [
        {
            id: 8,
            visible: true
        }
    ]
});
const netwerk7 = new GroupLayer({
    title: "Gemalen",
    layers: [netwerk7c, netwerk7b, netwerk7a],
    visible: true,
    listMode: "hide-children"
});
//--------------------------------
const netwerk10 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/10",
    title: "verhard oppervlak",
    visible: false,
});

const netwerk11 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/11",
    title: "blauwe aderen",
    visible: false,
    labelsVisible: false,
    outFields: ["*"],    
    popupTemplate: netwerk_BA,
    renderer: new SimpleRenderer({
        symbol: new SimpleLineSymbol({
            cap: "square",
            color: new Color([112,212,255,1]),
            join: "round",
            miterLimit: 2,
            style: "solid",
            width: 3
        })
    })
});

const netwerk1_SCI = new GroupLayer({
    title: "Huidige situatie (SCI)",
    layers: [netwerk10, netwerk2, netwerk11, netwerk1, netwerk7, netwerk6, netwerk3],
    visible: true
});
//------------------------------------------------------
//--------------- NETWERK SCII -------------------------
//------------------------------------------------------
const netwerk13 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/13",
    title: "Putten",
    visible: true,
    outFields: ["*"],    
    popupTemplate: netwerk_putten
});
const netwerk14 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/14",
    title: "Leidingen",
    visible: true,
    outFields: ["*"],
    popupTemplate: netwerk_leidingen
});
const netwerk15 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/15",
    title: "Verbindingen HWA-GEM",
    visible: true,
    labelsVisible: false,
    outFields: ["*"],    
    popupTemplate: netwerk_HWA_GEM
});
const netwerk16 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/16",
    title: "Verhard oppervlak",
    visible: false,
});
const netwerk17 = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Netwerk_upd_260616/MapServer/17",
    title: "Blauwe aderen",
    visible: false,
    labelsVisible: false,
    outFields: ["*"],    
    popupTemplate: netwerk_BA,
    renderer: new SimpleRenderer({
        symbol: new SimpleLineSymbol({
            cap: "square",
            color: new Color([18,150,226,1]),
            join: "round",
            miterLimit: 2,
            style: "solid",
            width: 6
        })
    })
});
const netwerk1_SCII = new GroupLayer({
    title: "Toekomstige situatie (SCII)",
    layers: [netwerk16, netwerk14, netwerk17, netwerk13, netwerk15 ],
    visible: false
});
//------------------------------------------------------
//--------------- 1D SCENARIO 1 ------------------------
//------------------------------------------------------    
export const D1S1B8b = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_1D_260616/MapServer/3",
    title: "FloodDepth",
    outFields: ["*"],    
    definitionExpression: "node_type <> 'Outfall'",
    popupTemplate: popuptempl_1D
});
export const D1S1B8a = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_1D_260616/MapServer/2",
    title: "Floodvol",
    outFields: ["*"], 
    definitionExpression: "node_type <> 'Outfall'"
});
export const D1S1B8 = new GroupLayer({
    title: "Bui08",
    laagcode: "HS_B08_1D",
    layers: [D1S1B8b, D1S1B8a],
    visible: false,
    listMode: "hide-children"
});
//---------------------------------------
const D1S1C2b = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_1D_260616/MapServer/6",
    title: "FloodDepth",
    outFields: ["*"],
    definitionExpression: "node_type <> 'Outfall'",
    popupTemplate: popuptempl_1D
});
const D1S1C2a = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_1D_260616/MapServer/5",
    title: "Floodvol",
    outFields: ["*"], 
    definitionExpression: "node_type <> 'Outfall'"
});
export const D1S1C2 = new GroupLayer({
    title: "Composietbui T=2",
    laagcode: "HS_BC2_1D",
    layers: [D1S1C2b, D1S1C2a],
    visible: true,
    listMode: "hide-children"
});
//------------------------------------------------------
//--------------- 1D SCENARIO 2 ------------------------
//------------------------------------------------------    
export const D1S2B8b = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_1D_260616/MapServer/10",
    title: "FloodDepth",
    outFields: ["*"],    
    definitionExpression: "node_type <> 'Outfall'",
    popupTemplate: popuptempl_1D
});
export const D1S2B8a = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_1D_260616/MapServer/9",
    title: "Floodvol",
    outFields: ["*"], 
    definitionExpression: "node_type <> 'Outfall'"
});
export const D1S2B8 = new GroupLayer({
    title: "Bui08",
    laagcode: "TS_B08_1D",
    layers: [D1S2B8b, D1S2B8a],
    visible: false,
    listMode: "hide-children"
});
//---------------------------------------
const D1S2C2b = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_1D_260616/MapServer/13",
    title: "FloodDepth",
    outFields: ["*"],
    definitionExpression: "node_type <> 'Outfall'",
    popupTemplate: popuptempl_1D
});
const D1S2C2a = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_1D_260616/MapServer/12",
    title: "Floodvol",
    outFields: ["*"],
    definitionExpression: "node_type <> 'Outfall'"
});
export const D1S2C2 = new GroupLayer({
    title: "Composietbui T=2",
    laagcode: "TS_BC2_1D",
    layers: [D1S2C2b, D1S2C2a],
    visible: true,
    listMode: "hide-children"
});
//------------------------------------------------------
//--------------- 2D SCENARIO 1 ------------------------
//------------------------------------------------------    
//---------------------------------------
export const S1t2w = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_2D_SCI_260616/MapServer/5",
    title: "Composietbui T=2 - 2D water-op-straat ",
    laagcode: "HS_2D_BC2_WoS",
    outFields: ["*"],
    popupTemplate: popuptempl_2Dwos
});
export const S1t2p = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_2D_SCI_260616/MapServer/4",
    title: "Composietbui T=2 - risicopanden",
    laagcode: "HS_2D_BC2_RP",
    outFields: ["*"],
    popupTemplate: popuptempl_2Dpand
});
export const S1T2 = new GroupLayer({
    title: "Composietbui T=2",
    laagcode: "HS_2D_BC2_WoSRP",
    layers: [S1t2w, S1t2p],
    visible: true
});
//---------------------------------------
export const S1b8w = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_2D_SCI_260616/MapServer/2",
    title: "70mm in 1 uur - 2D water-op-straat ",
    laagcode: "HS_2D_B70_WoS",
    outFields: ["*"],
    popupTemplate: popuptempl_2Dwos
});
export const S1b8p = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_2D_SCI_260616/MapServer/1",
    title: "70mm in 1 uur - risicopanden",
    laagcode: "HS_2D_B70_RP",
    outFields: ["*"],
    popupTemplate: popuptempl_2Dpand
});
export const S1B8 = new GroupLayer({
    title: "70mm in 1 uur",
    laagcode: "HS_2D_B70_WoSRP",
    layers: [S1b8w, S1b8p],
    visible: false
});
//------------------------------------------------------
//--------------- 2D SCENARIO 2 ------------------------
//------------------------------------------------------
export const t2w = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_2D_SCII_260616/MapServer/2",
    title: "Composietbui T=2 - 2D water-op-straat ",
    laagcode: "TS_2D_BC2_WoS",
    outFields: ["*"],
    popupTemplate: popuptempl_2Dwos
});
export const t2p = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_2D_SCII_260616/MapServer/1",
    title: "Composietbui T=2 - risicopanden",
    laagcode: "TS_2D_BC2_RP",
    outFields: ["*"],
    popupTemplate: popuptempl_2Dpand
});
export const T2 = new GroupLayer({
    title: "Composietbui T=2",
    laagcode: "TS_2D_BC2_WoSRP",
    layers: [t2w, t2p],
    visible: true
});
//---------------------------------------
export const b8w = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_2D_SCII_260616/MapServer/5",
    title: "70mm in 1 uur - 2D water-op-straat ",
    laagcode: "TS_2D_B70_WoS",
    outFields: ["*"],
    popupTemplate: popuptempl_2Dwos
});
export const b8p = new FeatureLayer({
    url: "https://ags.witteveenbos.com/wb/rest/services/142190_Tilburg/142190_Resultaten_2D_SCII_260616/MapServer/4",
    title: "70mm in 1 uur - risicopanden",
    laagcode: "TS_2D_B70_RP",
    outFields: ["*"],
    popupTemplate: popuptempl_2Dpand
});
export const B8 = new GroupLayer({
    title: "70mm in 1 uur",
    laagcode: "TS_2D_B70_WoSRP",
    layers: [b8w, b8p],
    visible: false
});
//---------------------------------------------------------------------------------------------------------------------------------------------------------------------
//---------------------------------------------------------------------------------------------------------------------------------------------------------------------
//------------------------------ lagenstructuur opmaken ------------------------------------------------
//---------------------------------------------------------------------------------------------------------------------------------------------------------------------
//---------------------------------------------------------------------------------------------------------------------------------------------------------------------
//---------------------------------------
// Algemeen
//---------------------------------------
export const graphicsLayer = new GraphicsLayer({
    title: "Analyse polygoon",
    listMode: "hide"
});
//---------------------------------------
// Netwerk
//---------------------------------------
export const netwerkLayer = new GroupLayer({
    title: "Netwerk",
    layers: [netwerk1_SCII, netwerk1_SCI],
    visible: true
});
//---------------------------------------
// 1D scenario
//---------------------------------------
export const D1_Scenario1 = new GroupLayer({
    title: "Huidige situatie (SCI)",
    layers: [D1S1C2, D1S1B8],
    visible: true
});
export const D1_Scenario2 = new GroupLayer({
    title: "Toekomstige situatie (SCII)",
    layers: [D1S2C2, D1S2B8],
    visible: false
});
// Alle 1D onder 1 kopje
export const D1 = new GroupLayer({
    title: "Resultaten 1D",
    layers: [D1_Scenario2, D1_Scenario1],
    visible: false
});
//---------------------------------------
// 2D scenario
//---------------------------------------
export const Scenario1 = new GroupLayer({
    title: "Huidige situatie (SCI)",
    layers: [S1T2, S1B8],
    visible: true
});
export const Scenario2 = new GroupLayer({
    title: "Toekomstige situatie (SCII)",
    layers: [T2, B8],
    visible: false
});
// Alle 2D onder 1 kopje
export const tweeD = new GroupLayer({
    title: "Resultaten 2D",
    layers: [Scenario2, Scenario1],
    visible: false
});
//------------------------------------------------------
//------------------------------------------------------
